"use client";

import { c as _c } from "react/compiler-runtime";
import { useCompactMode } from "@/contexts/CompactModeContext";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useState } from "react";
import WaveDropActionsAddReaction from "./WaveDropActionsAddReaction";
import WaveDropActionsBoost from "./WaveDropActionsBoost";
import WaveDropActionsEdit from "./WaveDropActionsEdit";
import WaveDropActionsMore from "./WaveDropActionsMore";
import WaveDropActionsQuickReact from "./WaveDropActionsQuickReact";
import WaveDropActionsRate from "./WaveDropActionsRate";
import WaveDropActionsReply from "./WaveDropActionsReply";
interface WaveDropActionsProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly showVoting?: boolean | undefined;
  readonly onReply: () => void;
  readonly onEdit?: (() => void) | undefined;
}
export default function WaveDropActions(t0) {
  const $ = _c(34);
  const {
    drop,
    activePartIndex,
    showVoting: t1,
    onReply,
    onEdit
  } = t0;
  const showVoting = t1 === undefined ? true : t1;
  const {
    isMemesWave
  } = useSeizeSettings();
  const compact = useCompactMode();
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false);
  let t2;
  if ($[0] !== drop || $[1] !== isMemesWave || $[2] !== showVoting) {
    t2 = showVoting && !(drop.drop_type === ApiDropType.Participatory && isMemesWave(drop.wave.id));
    $[0] = drop;
    $[1] = isMemesWave;
    $[2] = showVoting;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const shouldShowVoting = t2;
  const t3 = `tw-absolute tw-right-2 tw-z-20 ${compact ? "-tw-top-4" : "tw-top-0"} tw-transition-opacity tw-duration-200 tw-ease-in-out ${isMoreDropdownOpen ? "tw-opacity-100" : "tw-opacity-0 desktop-hover:group-hover:tw-opacity-100 desktop-hover:hover:tw-opacity-100"}`;
  let t4;
  let t5;
  if ($[4] !== drop) {
    t4 = <WaveDropActionsQuickReact drop={drop} />;
    t5 = <WaveDropActionsAddReaction drop={drop} />;
    $[4] = drop;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== activePartIndex || $[8] !== drop || $[9] !== onReply) {
    t6 = <WaveDropActionsReply onReply={onReply} drop={drop} activePartIndex={activePartIndex} />;
    $[7] = activePartIndex;
    $[8] = drop;
    $[9] = onReply;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== drop) {
    t7 = <WaveDropActionsBoost drop={drop} />;
    $[11] = drop;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== drop || $[14] !== onEdit) {
    t8 = onEdit && drop.drop_type !== ApiDropType.Participatory && <WaveDropActionsEdit drop={drop} onEdit={onEdit} />;
    $[13] = drop;
    $[14] = onEdit;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== drop) {
    t9 = <WaveDropActionsMore drop={drop} onOpenChange={setIsMoreDropdownOpen} />;
    $[16] = drop;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className="tw-flex tw-h-9 tw-items-center tw-gap-x-0.5 tw-rounded-xl tw-bg-iron-950 tw-px-1 tw-shadow-md tw-shadow-black/20 tw-ring-1 tw-ring-inset tw-ring-iron-700/40">{t4}{t5}{t6}{t7}{t8}{t9}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== drop || $[26] !== shouldShowVoting) {
    t11 = shouldShowVoting && <WaveDropActionsRate drop={drop} />;
    $[25] = drop;
    $[26] = shouldShowVoting;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11) {
    t12 = <div className="tw-flex tw-items-center tw-gap-x-2">{t10}{t11}</div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t3) {
    t13 = <div className={t3}>{t12}</div>;
    $[31] = t12;
    $[32] = t3;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}